var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApiNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180,
    height: 140,
    viewBox: "0 0 180 140",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.7693 18.7786C20.2489 24.8705 3.94479 40.9442 3.04944 63.0314C2.5465 75.327 5.19385 106.865 43.7269 115.064C105.578 128.22 161.205 123.771 172.883 92.0992C183.285 63.8977 166.815 26.4131 135.925 18.6501C114.144 13.1954 74.948 6.85197 38.7693 18.7786Z",
    fill: "#E6E6E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M57 130C68.0457 130 77 128.657 77 127C77 125.343 68.0457 124 57 124C45.9543 124 37 125.343 37 127C37 128.657 45.9543 130 57 130Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 35C7 35 26.5001 37.406 37.326 52.5086C48.3144 67.8258 61.9813 94.9529 87.6901 95.9639C118.582 97.1782 130.725 67.4361 138.738 57.2472C146.751 47.0584 156.624 37.0558 172 35.0113",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 96C7 96 26.5001 93.599 37.326 78.4865C48.3144 63.1594 61.9813 36.0417 87.6901 35.0361C118.582 33.8215 130.725 63.5718 138.738 73.7635C146.751 83.9552 156.624 93.9605 172 96",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46C63 58.4543 63 72.2352 63 83",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81 52V36",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81 93C81 88.954 81 83.7601 81 78",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M99 93C99 79.6935 99 54.5365 99 36",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116 84C116 73.0814 116 58.7623 116 46",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14 93C14 79.651 14 55.2509 14 37",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33 48V64.3236C33 70.9429 33 77.395 33 83",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M148 82C148 72.1943 148 60.136 148 49",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165 93C165 87.7765 165 80.6989 165 73",
    stroke: "#C9C9C9",
    strokeWidth: 10.15,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64 87.0611L57.952 58.1443C57.2073 57.7918 56.4277 57.5097 55.6246 57.3022C54.8449 57.1827 50.9639 56.596 49.4734 57.4761C47.9829 58.3561 50.4881 90 50.4881 90L64 87.0611Z",
    fill: "#24285B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104.338L50.3306 124L49 123.656L54.7978 103L60 104.338Z",
    fill: "#F4A28C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4737 124.708C50.4737 124.708 50.6988 126.158 51.5665 126.642C52.4342 127.125 51.9371 128.679 50.6285 127.661C50.2219 127.348 49.8389 126.992 49.484 126.596C49.1494 126.249 48.7469 126.015 48.3161 125.917C48.2348 125.891 48.1619 125.835 48.1074 125.757C48.0528 125.679 48.0192 125.582 48.0113 125.479C47.8565 124.679 49.348 124 49.348 124L50.4737 124.708Z",
    fill: "#0D9F3F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3457 102L64 125.465L62.6317 126L57 104.083L62.3457 102Z",
    fill: "#F4A28C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6848 125C63.6848 125 64.4417 125.861 65.3012 125.726C66.1608 125.591 66.4045 126.909 65.0019 126.913C64.5722 126.92 64.1428 126.885 63.719 126.806C63.3217 126.752 62.9184 126.81 62.5474 126.974C62.4726 127.004 62.3909 127.008 62.314 126.985C62.2371 126.961 62.1691 126.912 62.1197 126.844C61.6921 126.378 62.5474 125.116 62.5474 125.116L63.6848 125Z",
    fill: "#0D9F3F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8057 87L66 122H57.6896L57 90.4977L62.8057 87Z",
    fill: "#24285B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M62.8057 87L66 122H57.6896L57 90.4977L62.8057 87Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48 87.0175L50.3406 95.4266C51.8684 100.903 51.7714 106.768 50.0633 112.181L48 118.725L57.874 122L60.2679 111.248C61.2537 106.83 61.1488 102.205 59.964 97.845L59.9214 97.6877C59.3949 95.7522 59.4698 93.6806 60.1344 91.7965C60.799 89.9125 62.0159 88.3221 63.5948 87.2739L64 87L48 87.0175Z",
    fill: "#24285B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8152 76.3917C72.1249 77.8169 72.0445 79.2844 71.5804 80.6785C71.3415 81.373 70.923 82.0125 70.3561 82.5492C69.7893 83.0858 69.0886 83.506 68.3063 83.7783C66.9662 84.1503 65.5088 84.0512 64.2538 83.5028C63.0062 82.9577 61.9331 82.1591 61.128 81.1766C58.7558 78.4476 60.6832 73.7581 61.8446 70.4993C62.4623 68.8143 63.9449 63.5419 66.6631 65.3859C68.1272 66.3715 68.9858 68.9309 69.7024 70.351C70.7087 72.2776 71.4189 74.3081 71.8152 76.3917Z",
    fill: "#0D9F3F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M71.8215 76.3727C72.1214 77.8022 72.0427 79.2686 71.5906 80.6704C71.3748 81.3517 70.9777 81.9844 70.4285 82.5222C69.8793 83.0599 69.1918 83.489 68.4165 83.7781C67.7723 83.9625 67.0886 84.0332 66.4094 83.9856C65.7303 83.938 65.0706 83.7733 64.4729 83.5019C63.2477 82.9408 62.2064 82.1402 61.4399 81.1698C60.2876 79.7628 59.5187 78.1649 59.1865 76.4871C58.8543 74.8093 58.9668 73.0917 59.5161 71.4534C60.1061 69.7641 64.1523 63.4849 66.7942 65.3389C68.2113 66.327 69.0513 68.8929 69.7439 70.3166C70.7346 72.2568 71.4325 74.2908 71.8215 76.3727Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47.1952C54 47.1952 51.5974 45.0182 49.7117 46.5404C47.8259 48.0625 49.1069 54.2101 45 52.8001C45 52.8001 49.4588 56.7647 52.5816 50.2808L54 47.1952Z",
    fill: "#FFD200"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0528 51C53.0528 51 51.5114 50.7351 52.1588 48.1872C52.8061 45.6393 54.5068 45.7339 55 46.4024L53.0528 51Z",
    fill: "#0D9F3F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9838 50.0482C56.8626 51.1969 56.5851 52.3245 56.1586 53.4008C56.099 53.525 56.015 53.6364 55.9115 53.7287C55.808 53.8209 55.6869 53.8923 55.5553 53.9386C55.4237 53.985 55.2841 54.0054 55.1445 53.9988C55.0048 53.9921 54.8679 53.9585 54.7415 53.8999C54.3226 53.7337 53.9612 53.4527 53.7004 53.0904C53.4396 52.7281 53.2904 52.2998 53.2705 51.8566L53.0014 49.9601C52.9862 49.5751 53.0931 49.1949 53.3073 48.872C53.5215 48.5491 53.8325 48.2995 54.1973 48.1576C55.5367 47.5528 57.1811 48.7975 56.9838 50.0482Z",
    fill: "#F4A28C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4488 51L52 57.5283L56 58L55.4646 53.1857L53.4488 51Z",
    fill: "#F4A28C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M54.8939 53.3425C54.5634 53.2782 54.267 53.1599 54.036 53C54.036 53 53.7132 53.6658 55 54L54.8939 53.3425Z",
    fill: "#CE8172"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9873 50.625C52.9873 50.625 53.1205 50.0406 52.5239 50.0013C51.9273 49.9621 51.7303 50.8081 52.5239 51L52.9873 50.625Z",
    fill: "#F4A28C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6741 49.5231C56.0416 49.5595 55.4081 49.4791 54.7999 49.2851C54.7999 49.2851 54.1548 51.6156 52.3696 52C52.3696 52 51.1072 48.2419 53.2483 47.1194C55.0446 46.1798 56.4016 45.2891 57.6362 46.8509C57.8141 47.0744 57.9325 47.3472 57.9785 47.6395C58.0245 47.9319 57.9963 48.2325 57.897 48.5084C57.7976 48.7844 57.631 49.025 57.4153 49.2039C57.1996 49.3829 56.9431 49.4933 56.6741 49.5231Z",
    fill: "#FFD200"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9118 58C51.7615 66.8481 55.2794 88.1262 56 97.062H55.6198L45.5031 98C45.5031 98 39.5964 71.0115 40.0219 64.972C40.3 61.028 45.0321 59.1794 48.2776 58.3895C48.8904 58.1975 49.4465 58.0823 49.9118 58Z",
    fill: "#0D9F3F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9815 72.3588C65.0849 74.2885 64.463 76.3923 64.1425 78.5797L63.9954 98L61.5034 97.8643C61.3333 95.6022 59.0023 64.9164 58 58L61.554 59.6344C62.8575 60.2168 64.0387 61.15 65.0114 62.3659C67.9585 66.138 67.0436 70.0232 65.9815 72.3588Z",
    fill: "#0D9F3F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55 50.5237C55 50.5237 55 49.9663 54.4488 50.0016C53.8976 50.0369 53.805 50.6825 54.4488 51L55 50.5237Z",
    fill: "#F4A28C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.029 56.6497C51.029 56.6497 50.5916 55.3207 53.1117 55.0442C55.6319 54.7677 57.64 55.8106 56.8099 57.547C56.8099 57.547 54.9409 59.0216 51.029 56.6497Z",
    fill: "#0D9F3F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M51.029 56.6497C51.029 56.6497 50.5916 55.3207 53.1117 55.0442C55.6319 54.7677 57.64 55.8106 56.8099 57.547C56.8099 57.547 54.9409 59.0216 51.029 56.6497Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M49.2661 62C49.2661 62 51.9 66.1537 49.2661 71.7937C46.6321 77.4337 48.4311 79.6298 56.5178 79.5244L66 73.829C66 73.829 65.0865 75.9363 65.0361 76.9401L64.8063 87H46.5033L46.1894 85.8909L42.642 79.469L41 71.339L49.2661 62Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M55 82.6381C56.5472 81.6064 72.0727 68.2053 81.5001 60L85 64.0358C84.9306 64.0893 78.3736 69.8036 71.806 75.4591C62.6027 83.3758 58.0464 87 58.0464 87C58.0464 87 55.0373 82.6114 55 82.6381Z",
    fill: "#C9C9C9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M61.6794 81C61.6794 81 62.9186 82.9307 60.5243 83.3372C58.13 83.7436 58.0564 85 58.0564 85L53 84.4042L61.6794 81Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7755 64.734C50.0102 63.841 49.9723 62.8966 49.6666 62.0261C49.3609 61.1555 48.802 60.4 48.064 59.8597C47.326 59.3194 46.4437 59.0199 45.5343 59.001C44.6249 58.982 43.7314 59.2445 42.9721 59.7535C38.9193 62.4991 33.1805 68.1934 35.5582 77.6437C39.1031 91.7561 50.0078 87.105 58 81.7621L56.7463 79.5986C56.7463 79.5986 45.0256 83.2118 43.7233 76.886C43.5702 76.0668 43.613 75.2222 43.8481 74.4233C44.0832 73.6244 44.5037 72.8946 45.0742 72.2953C46.5548 70.6864 48.9703 67.7212 49.7755 64.734Z",
    fill: "#0D9F3F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M49.7755 64.734C50.0102 63.841 49.9723 62.8966 49.6666 62.0261C49.3609 61.1555 48.802 60.4 48.064 59.8597C47.326 59.3194 46.4437 59.0199 45.5343 59.001C44.6249 58.982 43.7314 59.2445 42.9721 59.7535C38.9193 62.4991 33.1805 68.1934 35.5582 77.6437C39.1031 91.7561 50.0078 87.105 58 81.7621L56.7463 79.5986C56.7463 79.5986 45.0256 83.2118 43.7233 76.886C43.5702 76.0668 43.613 75.2222 43.8481 74.4233C44.0832 73.6244 44.5037 72.8946 45.0742 72.2953C46.5548 70.6864 48.9703 67.7212 49.7755 64.734Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57 79.8868C57 79.8868 60.4517 77.8915 61.7717 79.8868C63.0918 81.882 58.2552 82 58.2552 82L57 79.8868Z",
    fill: "#F4A28C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M65.897 79.3795C65.8456 79.1183 65.7538 78.873 65.627 78.658C65.5002 78.443 65.3409 78.2628 65.1586 78.1281C65.0897 78.0704 65.0124 78.031 64.9314 78.0124C64.8503 77.9937 64.7672 77.9962 64.6869 78.0195C64.6066 78.0429 64.5308 78.0867 64.4641 78.1484C64.3973 78.21 64.341 78.2882 64.2984 78.3784C64.0838 78.8172 63.9806 79.3302 64.003 79.847C63.9887 80.276 64.0453 80.7041 64.1691 81.1031C64.2332 81.3023 64.3305 81.4811 64.4542 81.6271C64.5779 81.7731 64.7251 81.8828 64.8854 81.9484C66.1037 82.3498 66.1037 80.3051 65.897 79.3795Z",
    fill: "#F4A28C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 38C52.5376 38 55 35.7614 55 33C55 30.2386 52.5376 28 49.5 28C46.4624 28 44 30.2386 44 33C44 35.7614 46.4624 38 49.5 38Z",
    fill: "#E6E6E6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38C55.6569 38 57 36.6569 57 35C57 33.3431 55.6569 32 54 32C52.3431 32 51 33.3431 51 35C51 36.6569 52.3431 38 54 38Z",
    fill: "#C9C9C9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M132.75 90H128.25L126 95L128.25 100H132.75L135 95L132.75 90Z",
    fill: "#E6E6E6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M140.499 96H135.501L133 101.003L135.501 106H140.499L143 101.003L140.499 96Z",
    fill: "#E6E6E6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M125.749 32H121.246L119 36L121.246 40H125.749L128 36L125.749 32Z",
    fill: "#E6E6E6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M133.75 27H129.25L127 31.4972L129.25 36H133.75L136 31.4972L133.75 27Z",
    fill: "#E6E6E6"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M133.75 38H129.25L127 42L129.25 46H133.75L136 42L133.75 38Z",
    fill: "#E6E6E6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M124.585 121.56C124.585 121.56 120.823 120.1 120 115.133C120 115.133 125.835 113.459 126 122L124.585 121.56Z",
    fill: "#0D9F3F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M124.614 120.987C124.614 120.987 121.266 115.307 124.213 110C124.213 110 129.867 113.851 127.358 121L124.614 120.987Z",
    fill: "#0D9F3F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M126 120.981C126 120.981 127.494 115.112 131.919 114C131.919 114 132.756 117.814 129.037 121L126 120.981Z",
    fill: "#0D9F3F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M122 121L122.971 125.982L129.101 126L130 121.027L122 121Z",
    fill: "#24285B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiNotFound);
export default __webpack_public_path__ + "static/media/api_not_found.e867b113b8366f81e193a1a3374481a5.svg";
export { ForwardRef as ReactComponent };